import { ContrastGraphQLFieldConfig } from '..'
import {
  GenericMutationResponse,
  GenericMutationResponseType
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLString,
  GraphQLID,
  GraphQLList
} from 'graphql'

/* Delete one or more server libraries by their hashes */
export const deleteServerLibrariesByHashes: ContrastGraphQLFieldConfig<
  any,
  Context,
  {
    readonly input: {
      readonly organizationID: string
      readonly serverLibraryHashes: string[]
      readonly serverID: number
    }
  },
  GenericMutationResponse
> = {
  description: 'Delete server libraries by hashes',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: {
    input: {
      type: new GraphQLInputObjectType({
        name: 'DeleteServerLibrariesByHashesArgs',
        description:
          'Parameters that describe a "delete server libraries by hashes" operation',
        fields: () => ({
          serverLibraryHashes: {
            description: 'The hashes of the server libraries being deleted',
            type: new GraphQLNonNull(new GraphQLList(GraphQLString))
          },
          serverID: {
            description:
              'The ID of the server the libraries are associated with',
            type: new GraphQLNonNull(GraphQLID)
          },
          organizationID: {
            description:
              'The ID of the organization that the library belongs to',
            type: new GraphQLNonNull(GraphQLID)
          }
        })
      })
    }
  },
  resolve: async (_, args, context) => {
    const {
      input: { organizationID, serverLibraryHashes, serverID }
    } = args
    const { connector } = context
    await connector.executeDelete(
      `/${organizationID}/servers/${serverID}/libraries`,
      {
        hashes: serverLibraryHashes
      }
    )
    return { _placeholder: true }
  }
}
